/**
 * Backend (PlanLimitException) returns HTTP 409 with the structured payload:
 *   { code: 'PLAN_LIMIT_EXCEEDED', resource, limit, current, requested,
 *     upgradeUrl, message }
 *
 * Frontend create-mutation `onError` handlers use this to pivot from a raw
 * error toast to the canonical upgrade prompt (UpgradeDialog).
 */
export function isPlanLimitError(e: unknown): boolean {
  const payload = (e as { payload?: { code?: string } } | null | undefined)
    ?.payload;
  return payload?.code === 'PLAN_LIMIT_EXCEEDED';
}
